import Immutable from 'immutable';
import moment from 'moment';
import React from 'react';
import { Link } from 'react-router-dom';

import TableAction from 'sharedreact/components/TableAction';
import TableActions from 'sharedreact/components/TableActions';
import TableContainer from 'sharedreact/containers/TableContainer';
import SortOrder from 'sharedreact/data/SortOrder';
import TableColumn from 'sharedreact/data/TableColumn';
import { RangeType } from 'sharedreact/stores/generic/Type';
import { translate } from 'sharedreact/utils/LanguageSupport';

import Token from 'workspaces/launcher/data/Token';

function _showTokenDate (value: moment.Moment | null) {
  return (value != null && moment.isMoment(value)) ? value.locale(moment.locale()).format('LLL') : '';
}

type Props = {
  language: string,
  className?: string,
  tokens: Immutable.List<Token | null>,
  selection: Immutable.Set<string>,
  showSelection: boolean,
  sortOrder: SortOrder,
  emptyTableText?: string,

  onRevokeToken: (token: Token) => void,
  onSortOrderChange: (sortOrder: SortOrder) => void,
  onItemSelect?: (id: string) => void,
  setVisibleRange: (visibleRange: RangeType) => void
};

class TokensTable extends React.Component<Props> {
  override render (): React.ReactNode {
    const { className, tokens, emptyTableText,
      language, // eslint-disable-line no-unused-vars
      selection, showSelection, sortOrder,
      onRevokeToken, onSortOrderChange, onItemSelect,
      setVisibleRange
    } = this.props;

    const tableColumns = Immutable.List<TableColumn<Token>>([
      {
        title: translate('launcher.admin.tokens.user'),
        width: '30%',
        renderCell: (token: Token, row: number, col: number) => token.userName,
        selectable: false,
        movable: true,
        name: 'user'
      },
      {
        title: translate('launcher.admin.tokens.creationdate'),
        width: '20%',
        renderCell: (token: Token, row: number, col: number) => _showTokenDate(token.creationDate),
        selectable: true,
        movable: true,
        name: 'creationDate'
      },
      {
        title: translate('launcher.admin.tokens.tags'),
        width: '20%',
        renderCell: (token: Token, row: number, col: number) => token.tags,
        selectable: true,
        movable: true,
        name: 'tags'
      },
      {
        title: translate('launcher.admin.tokens.grantedby'),
        width: '20%',
        renderCell: (token: Token, row: number, col: number) => token.grantedBy,
        selectable: true,
        movable: true,
        name: 'grantedBy'
      },
      {
        title: translate('launcher.admin.tokens.actions'),
        width: '10%',
        renderCell: (token: Token, row: number, col: number) => (
          <TableActions>
            <Link
              id={'ae_token_edit_' + row}
              className='esko_tableaction esko_tableactionedit'
              to={'/admin?tab=managetokens&action=edit&id=' + token.id}
              title={translate('launcher.admin.tokens.tooltip.edit')}
            />
            <TableAction<Token>
              id={'ae_token_revoke_' + row}
              className='esko_tableactionremove'
              item={token}
              title={translate('launcher.admin.tokens.tooltip.revoke')}
              onClick={onRevokeToken}
            />
          </TableActions>
        ),
        selectable: false,
        movable: true,
        name: 'actions'
      }
    ]);

    return (
      <TableContainer<Token>
        id='ae_tokens_table'
        tableName='TokensTable'
        tableColumns={tableColumns}
        rowData={tokens}
        selection={selection}
        showSelection={showSelection}
        sortOrder={sortOrder}
        className={className}
        onSortOrderChange={onSortOrderChange}
        setVisibleRange={setVisibleRange}
        onItemSelect={onItemSelect}
        emptyTableText={emptyTableText}
      />
    );
  }
}

export default TokensTable;
